// ページ読み込み完了後に実行
document.addEventListener('DOMContentLoaded', function() {
  // 要素取得
  var meadButton = document.getElementById('antelopeMeadButton');
  var meadPopup = document.getElementById('antelopeMeadPopup');
  var meadClose = document.querySelector('.antelope-mead-close');
  
  // 初期状態では非表示
  if (meadPopup) {
    meadPopup.style.display = 'none';
  }
  
  // ボタンクリックでポップアップを表示
  if (meadButton) {
    meadButton.onclick = function(e) {
      e.preventDefault();
      if (meadPopup) {
        meadPopup.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
    };
  }
  
  // ×ボタンクリックでポップアップを非表示
  if (meadClose) {
    meadClose.onclick = function(e) {
      e.preventDefault();
      if (meadPopup) {
        meadPopup.style.display = 'none';
        document.body.style.overflow = '';
      }
    };
  }
  
  // ポップアップの外側クリックで非表示
  window.onclick = function(event) {
    if (event.target == meadPopup) {
      meadPopup.style.display = 'none';
      document.body.style.overflow = '';
    }
  };
});